/// <reference types="./updateModifyIndexes.d.ts" />
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { ok } from '@dossierhq/core';
import { buildSqliteSqlQuery } from '@dossierhq/database-adapter';
import { queryRun } from '../QueryFunctions.js';
export async function schemaUpdateModifyIndexes(database, context, deleteUniqueValueIndexes, renameUniqueValueIndexes) {
    if (deleteUniqueValueIndexes.length > 0) {
        const deleteResult = await queryRun(database, context, buildSqliteSqlQuery(({ sql, addValueList }) => {
            sql `DELETE FROM unique_index_values WHERE index_name IN ${addValueList(deleteUniqueValueIndexes)}`;
        }));
        if (deleteResult.isError())
            return deleteResult;
    }
    for (const [oldName, newName] of Object.entries(renameUniqueValueIndexes)) {
        const renameResult = await queryRun(database, context, buildSqliteSqlQuery(({ sql }) => {
            sql `UPDATE unique_index_values SET index_name = ${newName} WHERE index_name = ${oldName}`;
        }));
        if (renameResult.isError())
            return renameResult;
    }
    return ok(undefined);
}
//# sourceMappingURL=updateModifyIndexes.js.map